import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import styles from "./ConfirmationPop.module.scss";
import { useTranslation } from "react-i18next";



const ConfirmationPop = ({
  confirmation,
  setConfirmation,
  confirmHandler,
  type,
}) => {
  const { t } = useTranslation();

  const hideHandler = () => {
    setConfirmation(false);
  };

  const allModels = {
    logout: {
      title: t("modals.logoutTitle"),
      cancelText: t("common.no"),
      confirmText: t("common.yes"),
    },
    delete: {
      title: t("modals.deleteTitle"),
      cancelText: t("common.no"),
      confirmText: t("common.delete"),
    },
    addRoomType: {
      title: t("modals.roomTitle"),
      cancelText: t("common.cancel"),
      confirmText: t("common.create"),
    },
  };
  return (
    <>
      <Modal
        show={confirmation}
        className={`${styles.ConfirmationPop} transparentModal`}
        onHide={hideHandler}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <div className="px-md-5 text-center mx-auto">
            <h3 className="m-0 fw-bold text-dark">{allModels[type]?.title}</h3>
            <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
              <div className="px-2 w-100">
                <button
                  onClick={hideHandler}
                  className="fw-sbold d-flex align-items-center justify-content-center w-100 GreyBtn commonBtn"
                >
                  {allModels[type]?.cancelText}
                </button>
              </div>
              <div className="px-2 w-100">
                <button
                  onClick={confirmHandler}
                  className="fw-sbold d-flex align-items-center justify-content-center commonBtn text-white outline w-100"
                >
                  {allModels[type]?.confirmText}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmationPop;
